import React from 'react';
import { Link } from "react-router-dom";
import AuthApi from "../../api/auth";
import toast from 'react-hot-toast';
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";

let validationSchema = Yup.object({
   email: Yup.string()
      .required("Email is Required.")
      .email("Email is not valid.")
});

let ResetPassword = () => {
   return (
      <div className='bg-global'>
         <div className="container">
            <div className="row">
               <div className="col-12">
                  <div className="authContainerWrapper">
                     <div>
                        <h2 className="font-xxl pb-3">Forget Password</h2>
                        <Formik
                           initialValues={{
                              email: "",
                           }}
                           validationSchema={validationSchema}
                           onSubmit={async (values, { setSubmitting, resetForm }) => {
                              setSubmitting(true);
                              try {
                                 let res = await AuthApi.resetPassword(values)
                                 if (res.status == 200) {
                                    toast.success(res?.data?.msg);
                                    resetForm()
                                 }
                                 setSubmitting(false);
                              } catch (error) {
                                 console.log(error.message);
                                 setSubmitting(false);

                              }
                           }}
                        >
                           {({ isSubmitting, values, errors }) => (
                              <Form>
                                 <div className="form-group">
                                    <label>Email Address</label>
                                    <Field
                                       autoComplete="email"
                                       id="email"
                                       name="email"
                                       className="form-control rounded"
                                       placeholder="Info@example.com"
                                    />
                                    <ErrorMessage component="small" className='text-danger' name="email" />
                                 </div>
                                 <small className="my-3 text-danger">
                                    {/* <p>{ApiError}</p> */}
                                 </small>
                                 <div className="p-0 mt-3 text-left col-sm-12">
                                    <div className="mb-1 form-group">
                                       <button type="submit" disabled={isSubmitting} className="w-100 rounded-0 btn btn-dark">{isSubmitting ? "Loading..." : "Reset password"}</button>
                                    </div>
                                 </div>
                              </Form>
                           )}
                        </Formik>
                        <div className="form-group form-check py-3">
                           <Link exact="true" to="/login" className="d-flex justify-content-end align-items-center font-bold">Login to Account</Link>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default ResetPassword